export const IMPACT_PATH = '/impact';

export const NOTEBOOKS_PATH = `${IMPACT_PATH}/notebooks`;

export const FRAMES_PATH = `${IMPACT_PATH}/frames`;

export const BASE_CRUMBS = [{ label: 'Impact Analytics', to: NOTEBOOKS_PATH }];

export const NOTEBOOK_CRUMBS = [...BASE_CRUMBS, { label: 'Notebooks', to: NOTEBOOKS_PATH }];

export const FRAME_CRUMBS = [...BASE_CRUMBS, { label: 'Saved frames', to: FRAMES_PATH }];

export function framePath(id) {
  return `${IMPACT_PATH}/frames/${id}`;
}

export function notebookPath(path) {
  return `${NOTEBOOKS_PATH}/${String(path).split('/').map(encodeURIComponent).join('/')}`;
}

export function folderPath(folder) {
  return folder ? { path: NOTEBOOKS_PATH, query: { folder } } : { path: NOTEBOOKS_PATH };
}

export function apiPath(path) {
  return `api/impact_analytics/notebooks/${String(path).split('/').map(encodeURIComponent).join('/')}`;
}
